// extracted by mini-css-extract-plugin
module.exports = {"container":"content-panel-interaction_container__3UkF9"};